<script>
import TemplateMixin from './mixins/TemplateMixin';
import BaseGateway from './mixins/BaseGateway';

export default {
        name: "TwocheckoutGateway",
        mixins: [
            TemplateMixin,
            BaseGateway
        ],        
        computed:{
            gateway(){
                return 'twocheckout';
            }
        }
}
</script>
